import { PapiTag } from '@wix/da-papi-types';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import EmptyResult from '../../../EmptyResult';
import OrderDropdown from '../../_partials/OrderDropdown';
import BasePageLayout from '../../_partials/BasePageLayout';
import DefaultPageContent from '../../_partials/DefaultPageContent';
import { DailyChallengeArray } from './DailyChallenges/types';
import DailyChallengePageHeader from './DailyChallenges/DailyChallengePageHeader';
import SelectedDailyChallengeHeading from './DailyChallenges/SelectedDailyChallengeHeading';

import s from './TagPage.scss';

export interface Props {
  tag?: PapiTag;
  hasOrderSubnav?: boolean;
  dailyChallenges?: DailyChallengeArray;
}

const TagPage: React.FC<Props> = ({ tag, hasOrderSubnav, dailyChallenges }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  // precondition: backend won't send dailyChallenges unless we've matched a tag in them
  const daily_tags = useFlag('daily_tags');
  const showDailyChallenges = daily_tags && !!dailyChallenges;

  if (!tag) {
    return <EmptyResult />;
  }

  if (showDailyChallenges) {
    return (
      <BasePageLayout
        customHeader={
          <DailyChallengePageHeader
            tag={tag.tag}
            dailyChallenges={dailyChallenges}
          />
        }
        withTabHeader={false}
        withNetworkBar={false}
        withNavigation={false}
        contentClassName={s['daily-challeges-content-block']}
      >
        <SelectedDailyChallengeHeading
          className={s['current-challenge-header']}
          tag={tag.tag}
          dailyChallenges={dailyChallenges}
        />

        <DefaultPageContent />
      </BasePageLayout>
    );
  }

  return (
    <BasePageLayout
      wrapperClassName={s['root']}
      titleClassName={s['title']}
      title={
        !isMobile &&
        t('tagPage.headline', {
          postProcess: ['reactPostprocessor', 'featureBrancher'],
          tag: <span className={s['title-tag']}>{tag.tag}</span>,
        })
      }
      headerLeftSideContent={isMobile && `#${tag.tag}`}
      headerRightSideContent={
        hasOrderSubnav && <OrderDropdown className={s['order-dropdown']} />
      }
      withNetworkBar={false}
      withNavigation={false}
      contentClassName={s['content-block']}
    >
      <DefaultPageContent />
    </BasePageLayout>
  );
};
TagPage.displayName = 'TagPage';

export default TagPage;
